import React from 'react'
import "./iphone.css"
import Img from "./Images/1.png"
export default function Apple() {
  return (
    <div className='back'>
        <div className='name1'>
          <br/>
          <br/>
          <br/><br/>
        <h2 class="headline" style={{margin:"0"}} >iPhone 14 Pro</h2>
      <h3 style={{margin:"0"}} className="pro">Pro. Beyond.</h3>
      <h3 style={{color:"blue",margin:"0"}}>Learn More & Buy </h3>
        </div>
      <img src={Img} alt="" />
    </div>
  )
}
